import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-line" data-id="element-70" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-3 px-6 py-10 sm:flex-row sm:items-center sm:justify-between lg:px-10" data-id="element-71" data-mp="3r7pv1qpfy31v">
        <p className="font-mono text-[12px] tracking-tight text-white/40" data-id="element-72" data-mp="3mfyfscbqjjr1">
          indicadoresvip.com © 2026 - Todos los derechos reservados.
        </p>
        <p className="max-w-md text-[11px] leading-relaxed text-white/25" data-id="element-73" data-mp="3dhe0ll5dvs7k">
          El trading de instrumentos apalancados conlleva riesgo. Los resultados
          pasados no garantizan rendimientos futuros.
        </p>
      </div>
    </footer>;
}